import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from "react";

type Variant = "primary" | "danger" | "ghost" | "outline";

const variants: Record<Variant, CSSProperties> = {
  primary: { background: "#0f766e", color: "#fff", border: "1px solid #0f766e" },
  danger: { background: "#dc2626", color: "#fff", border: "1px solid #dc2626" },
  ghost: { background: "transparent", color: "#0f766e", border: "1px solid transparent" },
  outline: { background: "#fff", color: "#334155", border: "1px solid #cbd5e1" },
};

export function Button({
  variant = "outline",
  children,
  style,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; children: ReactNode }) {
  return (
    <button
      {...props}
      style={{
        minHeight: 32,
        padding: "7px 13px",
        borderRadius: 7,
        fontSize: 13,
        fontWeight: 700,
        cursor: props.disabled ? "not-allowed" : "pointer",
        opacity: props.disabled ? 0.55 : 1,
        fontFamily: "inherit",
        ...variants[variant],
        ...style,
      }}
    >
      {children}
    </button>
  );
}
